import { Box, Center, chakra, Container, Flex, Heading, HStack, Text, VStack } from '@chakra-ui/react'
import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'
import { useIntl } from 'react-intl'
import { CardIcon } from '../../icons/Card'
import { CheckIcon } from '../../icons/Check'
import { DeliveryBoxIcon } from '../../icons/DeliveryBox'
import { LANDING_MESSAGES } from '../../intl/messages'
import { BriddgyImage } from '../Misc/GatsbyImage'
export const HowtoShopCheaperwithBriddgy = chakra(({className})=>{
const intl = useIntl()
const data = useStaticQuery(graphql`
    {
        img: file(relativePath: {eq: "ecommerce-circle.png"}) {
        childImageSharp {
            gatsbyImageData
        }
        }
    }
`)
return(
    <Box w="100%" mb={[20, 20, "150px"]} className={className} as="section">
        <Container h="100%" maxW="container.xl">
          <Heading mb={4} as='h2' fontSize="hb3" fontWeight="700" textAlign="center">
          {intl.formatMessage(LANDING_MESSAGES.howtoshopcheaper)}
          </Heading>
          <Text mx='auto' maxW='container.md' mb={10} as='h3' textAlign="center">
          {intl.formatMessage(LANDING_MESSAGES.cheapshoppingandinternational)}
          </Text>
         <Flex>
            <VStack sx={{">div":{_hover:{boxShadow:"elevation_5"},transition:"0.2s ease-in-out",p:4,cursor:"pointer"}}} alignItems='flex-start' spacing={8} flex={1}>
                <HStack alignItems='center' spacing={4}>
                    <Box  flexShrink={0}  h={12} w={12} borderRadius="base" bg='success.light'>
                    <Center h='100%' w='100%' fontSize='700' color='success.dark'   >
                        +
                    </Center>
                    </Box>
                    <Box>
                    <Text as='h4' fontSize='600' fontWeight='bold'>{intl.formatMessage(LANDING_MESSAGES.howtoshop1_title)}</Text>
                    <Text variant='secondary'>
                    {intl.formatMessage(LANDING_MESSAGES.howtoshop1_description)}
                    </Text>
                    </Box>
                </HStack>
                <HStack alignItems='center' spacing={4}>
                    <Box  flexShrink={0}  h={12} w={12} borderRadius="base" bg='warning.light'>
                    <Center h='100%' w='100%' fontSize='500' color='warning.dark'   >
                        <CheckIcon alt={intl.formatMessage(LANDING_MESSAGES.howtoshop2_title)}/>
                    </Center>
                    </Box>
                    <Box>
                    <Text as='h4' fontSize='600' fontWeight='bold'>{intl.formatMessage(LANDING_MESSAGES.howtoshop2_title)}</Text>
                    <Text variant='secondary'>
                    {intl.formatMessage(LANDING_MESSAGES.howtoshop2_description)}
                    </Text>
                    </Box>
                </HStack>
                <HStack alignItems='center' spacing={4}>
                    <Box  flexShrink={0}  h={12} w={12} borderRadius="base" bg='lilaPurple.light'>
                    <Center h='100%' w='100%'  color='lilaPurple.dark'   >
                    <CardIcon alt={intl.formatMessage(LANDING_MESSAGES.howtoshop3_title)}/>
                    </Center>
                    </Box>
                    <Box>
                    <Text as='h4' fontSize='600' fontWeight='bold'>{intl.formatMessage(LANDING_MESSAGES.howtoshop3_title)}</Text>
                    <Text variant='secondary'>
                    {intl.formatMessage(LANDING_MESSAGES.howtoshop3_description)}
                    </Text>
                    </Box>
                </HStack>
                <HStack alignItems='center' spacing={4}>
                    <Box  flexShrink={0}  h={12} w={12} borderRadius="base" bg='cherryRed.light'>
                    <Center h='100%' w='100%' fontSize='700' color='cherryRed.dark'   >
                        <DeliveryBoxIcon alt={intl.formatMessage(LANDING_MESSAGES.howtoshop4_title)}/>
                    </Center>
                    </Box>
                    <Box>
                    <Text as='h4' fontSize='600' fontWeight='bold'>{intl.formatMessage(LANDING_MESSAGES.howtoshop4_title)}</Text>
                    <Text variant='secondary'>
                    {intl.formatMessage(LANDING_MESSAGES.howtoshop4_description)}
                    </Text>
                    </Box>
                </HStack>
            </VStack>
            <Box  justifyContent='flex-end' alignItems='center' d={['none','none','flex']} flex={1}>
                <BriddgyImage image={data.img.childImageSharp.gatsbyImageData} alt={intl.formatMessage(LANDING_MESSAGES.howtoshopcheaper)}/>
              
            </Box>
         </Flex>
        </Container>
      </Box>
)






})